import { memo } from 'react';
import * as THREE from 'three';

type Props = {
  innerRadius: number;
  outerRadius: number;
};

const Ring = ({ innerRadius, outerRadius }: Props) => {
  const geometry = new THREE.RingGeometry(innerRadius, outerRadius, 80);
  const material = new THREE.MeshBasicMaterial({ color: 0xffffff });

  return (
    <mesh
      geometry={geometry}
      material={material}
      rotation={[-Math.PI / 2, 0, 0]}
      position={[0, 0.04, 0]}
    >
      {/* optional children */}
    </mesh>
  );
};

export default memo(Ring);
